export default function isGamificationEnabled() {
    return process.env.GAMIFICATION_ENABLE === '1';
}
